import { IDc3AttestationDetail } from 'interfaces/dc3Attestation'
import { IDc3AttestationTemplateData } from './types'

export const mapAttestationDetailToPreview = (
  detail: IDc3AttestationDetail
): Partial<IDc3AttestationTemplateData> => ({
  companyFiscalName: detail.companyFiscalName,
  companyRfc: detail.companyRfc,
  patronalRegistration: detail.patronalRegistration,
  companyActivity: detail.companyActivity,
  trainingAgentName: detail.trainingAgentName,
  trainingAgentStpsRegistration: detail.trainingAgentStpsRegistration,
  thematicArea: detail.thematicArea,
  instructorName: detail.instructorName,
  instructorSignatureUrl: detail.instructorSignatureUrl,
  legalRepresentativeName: detail.legalRepresentativeName,
  legalRepresentativeSignatureUrl: detail.legalRepresentativeSignatureUrl,
  workersRepresentativeName: detail.workersRepresentativeName,
  workersRepresentativeSignatureUrl: detail.workersRepresentativeSignatureUrl,
})
